import { extendTheme } from '@chakra-ui/react';

const breakpoints = {
  sm: '30em', // 480px
  md: '48em', // 768px
  lg: '62em', // 992px
  xl: '135em', // 2160px
};

const theme = extendTheme({
  breakpoints,
});

export default theme;
